export const isDevelopment = (): boolean => {
  console.log('process.env', process.env);
  return false;
  return (
    process.env.NODE_ENV === 'development' || process.env.REACT_APP_API_URL === 'http://api.dev.bonato.reactapp.cz'
  );
};
